import * as React from 'react';
import { matchRoutes, useLocation } from 'react-router-dom';
import { INav, routes } from '../../layout/layoutConstants';

export interface IMiaRouteMatch {
  route: INav;
  pathname: string;
  params: Record<string, string>;
}

export interface IMiaRouteMatchResponse {
  rootRoute: IMiaRouteMatch;
  currentRoute: IMiaRouteMatch;
}

export function useMiaRouteMatch(): IMiaRouteMatchResponse | null {
  const loc = useLocation();

  const match = React.useMemo(() => matchRoutes(routes, loc.pathname), [routes, loc.pathname]) as
    | IMiaRouteMatch[]
    | null;

  const response = React.useMemo<IMiaRouteMatchResponse | null>(
    () =>
      match && match.length > 0
        ? {
            currentRoute: match[match.length - 1],
            rootRoute: match[0]
          }
        : null,
    [match]
  );

  return response;
}
